"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _immutable = require("immutable");

var _PlaybooksStore = _interopRequireDefault(require("crm_data/playbooks/stores/PlaybooksStore"));

var _CompaniesStore = _interopRequireDefault(require("crm_data/companies/CompaniesStore"));

var _ContactsStore = _interopRequireDefault(require("crm_data/contacts/ContactsStore"));

var _DealsStore = _interopRequireDefault(require("crm_data/deals/DealsStore"));

var _TicketsStore = _interopRequireDefault(require("crm_data/tickets/TicketsStore"));

var _ObjectTypes = require("customer-data-objects/constants/ObjectTypes");

var _ImmutableModel = require("customer-data-objects/model/ImmutableModel");

var _storesByType, _Map;

var storesByType = (_storesByType = {}, (0, _defineProperty2.default)(_storesByType, _ObjectTypes.COMPANY, _CompaniesStore.default), (0, _defineProperty2.default)(_storesByType, _ObjectTypes.CONTACT, _ContactsStore.default), (0, _defineProperty2.default)(_storesByType, _ObjectTypes.DEAL, _DealsStore.default), (0, _defineProperty2.default)(_storesByType, _ObjectTypes.TICKET, _TicketsStore.default), _storesByType);
var initialAssociations = (0, _immutable.Map)((_Map = {}, (0, _defineProperty2.default)(_Map, _ObjectTypes.CONTACT, (0, _immutable.Map)()), (0, _defineProperty2.default)(_Map, _ObjectTypes.COMPANY, (0, _immutable.Map)()), (0, _defineProperty2.default)(_Map, _ObjectTypes.DEAL, (0, _immutable.Map)()), (0, _defineProperty2.default)(_Map, _ObjectTypes.TICKET, (0, _immutable.Map)()), _Map));

function getObjectsMap(objectType, objectIds) {
  var objects = storesByType[objectType].get(objectIds).reduce(function (objectMap, object) {
    var objectId = (0, _ImmutableModel.getId)(object);
    return objectMap.set(objectId, object);
  }, (0, _immutable.Map)());
  return objects;
}

var PlaybookAssociationsDependency = {
  stores: [_PlaybooksStore.default, _CompaniesStore.default, _ContactsStore.default, _DealsStore.default, _TicketsStore.default],
  deref: function deref() {
    var requestedAssociationIds = _PlaybooksStore.default.get('requestedAssociationIds');

    if (!requestedAssociationIds) {
      return initialAssociations;
    }

    return requestedAssociationIds.reduce(function (associationsMap, objectIds, objectType) {
      return associationsMap.set(objectType, getObjectsMap(objectType, objectIds));
    }, initialAssociations);
  }
};
var _default = PlaybookAssociationsDependency;
exports.default = _default;
module.exports = exports.default;